<template>
  <Modal
    :title="title"
    :openModal="display"
    v-on:close-modal="$emit('close-modal')"
  >
    <template v-slot:content>
      <form
        action=""
        @submit.prevent="handleClick"
        id="deleteBorrowerForm"
      ></form>
    </template>
    <template v-slot:footer>
      <Button
        type="submit"
        form="deleteBorrowerForm"
        styling="primary"
        text="Delete"
      ></Button>
    </template>
  </Modal>
</template>

<script>
import Modal from '../../components/Modal/Modal.vue';
import Button from '../../components/Button/Button.vue';

export default {
  name: 'DeleteBorrower',
  emits: ['close-modal'],
  props: ['borrower', 'display'],
  components: {
    Modal,
    Button,
  },
  data() {
    return {
      title: 'Delete Borrower',
    };
  },
  methods: {
    handleClick() {
      this.$confirm({
        message: `Are you sure you want to delete this borrower?`,
        button: {
          no: 'Cancel',
          yes: 'Yes',
        },
        callback: (confirm) => {
          if (confirm) {
            this.deleteBorrower();
          }
        },
      });
    },
    deleteBorrower() {
      const { ref } = this.borrower;
      this.$store
        .dispatch(`borrowers/deleteBorrower`, {
          ref,
        })
        .then(() => {
          this.$emit('close-modal');
        })
        .catch((err) => {
          this.formErrors = err;
        });
    },
    checkBorrower() {
      if (this.borrower !== null) {
        this.title = `Delete ${this.borrower.name} (${this.borrower.ref}) borrower?`;
      }
    },
  },
  watch: {
    borrower: {
      handler() {
        this.checkBorrower();
      },
      deep: true,
    },
  },
  mounted() {
    if (!this.borrower) this.$emit('close-modal');
    else this.checkBorrower();
  },
};
</script>
